import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest, } from '@angular/common/http';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { RegistrationService } from '../services/registration.service';


@Component({
    selector: 'app-payment-details',
    templateUrl: './payment-details.component.html',
    styleUrls: ['./payment-details.component.scss']
})
export class PaymentDetailsComponent implements OnInit {
    test: any;
    showtext: any;
    showtext1: any;
    userid: any;
    pdflink:any;
    challanlink:any;
    datalist:any
    showform:boolean =false;
    processbar: boolean = false;
    showcard :boolean =false;
    trnsfailed:boolean = false;
    constructor(private route: ActivatedRoute, private router: Router, private regservice: RegistrationService) { }

    ngOnInit() {
        this.route.paramMap.subscribe(
            params => {
                this.test = +params.get('msg');
                this.userid = +params.get('id');
                if (this.test == 0) {
                    this.showcard = true;
                    this.trnsfailed = true
                    this.showtext = "Online Payment Transaction Failed. ";
                    this.showtext1 = "Login to Application Portal (using Login id and Password sent to your registered Mobile Number) and please try Online Payment again."
                }
                else if (this.test == 1) {
                    this.processbar = true;
                    this.showcard = true;
                    this.regservice.getformchallan(this.userid).then(res=>{
                        this.processbar = false;
                        this.showform = true;
                        this.datalist = res;
                        this.showtext = "Online Payment Transaction Successful.";
                        this.challanlink = this.datalist.challanLink;
                        this.pdflink = this.datalist.admitsLink;
                        this.showtext1 =" Login to Application Portal (using Login id and Password sent to your registered Mobile Number)";
                    }, error => {
                        this.processbar = false;
                    })
                }
            }
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/payment-details/payment-details.component.ts